import Axios from '../utils/axios-utils';

// create User
export const createUser = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/users`, {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            msisdn: data.msisdn,
            role: data.role,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create User error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create User failed" }
        };
    }
};



// get all users with page and limit
export const getAllUsers = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/users`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Users error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Users failed" }
        };
    }
};

// get all users list
export const getUsersMinimal = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/users/minimal`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Users error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Users failed" }
        };
    }
};


// get all user statuses
export const getAllUserStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/users/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All users statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All users statuses failed" }
        };
    }
};

// get all user roles
export const getAllUserRoles = async (accountId) => {
    try {
        
        const response = await Axios.get(`/accounts/${accountId}/users/roles`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All users roles error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All users roles failed" }
        };
    }
};


// update User status
export const updateUserStatus = async (accountId, userId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/users/${userId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update User Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update User Status failed" }
        };
    }
};

// update User
export const updateUser = async (accountId, userId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/users/${userId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update User error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update User failed" }
        };
    }
};